import { graphql } from "generated/gql";

export const CoreCollectionSiteLocationFieldsFragment = graphql(/* GraphQL */ `
  fragment CollectionSiteLocationFields on CollectionSiteLocation {
    id
    name
    description
    archived
  }
`);

export const LocationListFieldsFragment = graphql(/* GraphQL */ `
  fragment LocationListFields on Location {
    collectionSiteId
    id
    name
    description
    archived
  }
`);

export const LocationFieldsFragment = graphql(/* GraphQL */ `
  fragment LocationFields on Location {
    id
    collectionSiteId
    description
    name
    archived
    totalMaterial
    geometry
    geometryColor
    material(filter: $materialFilter, sort: $materialSort, searchTerm: $searchTerm) {
      nodes {
        ...MapMaterialListFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
`);

export const getLocationByNameDocument = graphql(/* GraphQL */ `
  query GetLocationByName($id: ID!, $name: String!, $materialFilter: PlantMaterialFilter, $materialSort: [MaterialSortInput!], $searchTerm: String) {
    collectionSite(id: $id) {
      location(name: $name) {
        ...LocationFields
      }
    }
  }
`);

export const getLocationDocument = graphql(/* GraphQL */ `
  query GetLocation($id: ID!) {
    location(id: $id) {
      id
      collectionSiteId
      description
      name
      archived
      totalMaterial
      geometry
      geometryColor
      material {
        nodes {
          id
          qualifier
          accession {
            id
            accessionNumber
            scientificName
          }
          collectionSiteLocation {
            id
            name
            code
            archived
          }
          materialGroup
          status
          primaryImage {
            ...MaterialImageFields
          }
          images {
            ...MaterialImageFields
          }
        }
      }
    }
  }
`);

export const getLocationsDocument = graphql(/* GraphQL */ `
  query GetLocations(
    $subdomain: String!
    $siteSlug: String!
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: LocationFilter
    $searchTerm: String
    $validAt: DateTime
    $includeArchived: Boolean
    $orderBy: LocationOrderByInput
  ) {
    org: organisationBySubdomain(subdomain: $subdomain) {
      site: collectionSiteBySlug(slug: $siteSlug) {
        locationsTotal(
          filter: $filter
          searchTerm: $searchTerm
          validAt: $validAt
          includeArchived: $includeArchived
        )
        locationsConnection(
          before: $before
          after: $after
          first: $first
          last: $last
          filter: $filter
          searchTerm: $searchTerm
          includeArchived: $includeArchived
          orderBy: $orderBy
        ) {
          nodes {
            ...LocationListFields
            geometry
            geometryColor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  }
`);

export const createLocationDocument = graphql(/* GraphQL */ `
  mutation CreateLocation($input: CreateLocationInput!, $materialFilter: PlantMaterialFilter, $materialSort: [MaterialSortInput!], $searchTerm: String) {
    createLocation(input: $input) {
      __typename
      success
      location {
        ...LocationFields
      }
      errors {
        ... on DuplicateCollectionSiteLocationCodeError {
          message
        }
      }
    }
  }
`);

export const updateLocationDocument = graphql(/* GraphQL */ `
  mutation UpdateLocation($id: ID!, $input: UpdateLocationInput!, $materialFilter: PlantMaterialFilter, $materialSort: [MaterialSortInput!], $searchTerm: String) {
    updateLocation(id: $id, input: $input) {
      __typename
      success
      location {
        ...LocationFields
      }
      errors {
        ... on DuplicateCollectionSiteLocationCodeError {
          message
        }
      }
    }
  }
`);

export const archiveLocationDocument = graphql(/* GraphQL */ `
  mutation ArchiveCollectionSiteLocation($id: ID!) {
    archiveCollectionSiteLocation(id: $id) {
      success
    }
  }
`);

export const SingleCollectionSiteLocationFieldsFragment = graphql(
  /* GraphQL */ `
    fragment SingleCollectionSiteLocationFields on CollectionSiteLocation {
      id
      name
      description
      totalPlantMaterial
      archived
    }
  `,
);

export const getCollectionSiteLocationDocument = graphql(/* GraphQL */ `
  query GetCollectionSiteLocation($id: ID!) {
    collectionSiteLocation(id: $id) {
      ...SingleCollectionSiteLocationFields
    }
  }
`);
